import PostManageImages from './post-manage-images';

export default PostManageImages;